import { render, staticRenderFns } from "./UserEditAcademicQualification.vue?vue&type=template&id=77dfa0aa&"
import script from "./UserEditAcademicQualification.vue?vue&type=script&lang=js&"
export * from "./UserEditAcademicQualification.vue?vue&type=script&lang=js&"
import style0 from "./UserEditAcademicQualification.vue?vue&type=style&index=0&id=77dfa0aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports